import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TrainingIdGuard } from './formularios/training-id.guard';
import { CalendarioTurnosComponent } from './turnos/calendario/calendario-turnos.component';

const routes: Routes = [
  { path: '', component: CalendarioTurnosComponent },
  {
    path: 'formularios',
    canActivate: [TrainingIdGuard],
    loadChildren: () =>
      import('./formularios/formularios.module').then(
        (m) => m.FormulariosModule
      ),
  },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
